import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { FC } from "react";

import { AnimationVideo } from "@/components/AnimationVideo";
import { RegistrationFlowLayout as EntranceTemplate, RegistrationActions } from "@/layouts/RegistrationFlowLayout";
import theme from "@/theme";

import WelcomeVideo from "@assets/image/registration_welcome.mp4";
import WelcomePoster from "@assets/image/registration_welcome_poster.jpg";

const useStyles = makeStyles(() => ({
  main: {
    "&&": {
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
      [theme.breakpoints.down("sm")]: {
        paddingTop: "calc(48px + env(safe-area-inset-top, 0px))",
        "@supports (min-height: 100dvh)": { minHeight: "100dvh" },
      },
      [theme.breakpoints.up("md")]: { minHeight: "auto" },
    },
  },
  body: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    flex: 1,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 24,
    flexShrink: 0,
  },
  head: { width: "100%" },
  heading: {
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 1.3,
    color: theme.palette.text.primary,
    textAlign: "center",
    [theme.breakpoints.up("md")]: { fontSize: 24 },
  },
  characterVideo: {
    width: "100%",
    maxWidth: 240,
    height: "auto",
    aspectRatio: "1 / 1",
    objectFit: "cover",
    display: "block",
    margin: "0 auto",
  },
  description: {
    marginTop: theme.spacing(1),
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 1.5,
    color: theme.palette.text.secondary,
    textAlign: "center",
    whiteSpace: "pre-line",
    [theme.breakpoints.up("md")]: { fontSize: 14 },
  },
}));

interface WelcomePageProps {
  onNext: () => void;
}

const WelcomePage: FC<WelcomePageProps> = ({ onNext }) => {
  const classes = useStyles();
  return (
    <EntranceTemplate mainClassName={classes.main} bodyClassName={classes.body}>
      <Box className={classes.content}>
        <AnimationVideo className={classes.characterVideo} src={WelcomeVideo} poster={WelcomePoster} loop />
        <Box className={classes.head}>
          <Typography component="h1" className={classes.heading}>
            投資力診断が完了しました！
          </Typography>
          <Typography className={classes.description}>
            {"よりあなたに合った診断結果をお届けするため、\nあなたについて教えてください"}
          </Typography>
        </Box>
      </Box>
      <RegistrationActions onNext={onNext} />
    </EntranceTemplate>
  );
};

export default WelcomePage;
